module.exports = __webpack_public_path__ + "img/jade_unboundtoken.346f298.png";